class ProductModuleImages extends HTMLElement {
  connectedCallback() {
    this.#toggleInput = this.querySelector('.switch');

    if (this.#toggleInput) {
      this.#toggleInput.addEventListener('change', this.#onToggleChange.bind(this));
      this.#updateToggleLabels();
    }
  }

  #toggleInput;

  #onToggleChange() {
    const isClosed = this.#toggleInput.checked;
    const closedImages = this.querySelectorAll('[data-image-role="closed"]');
    const openImages = this.querySelectorAll('[data-image-role="open"]');

    closedImages.forEach((image) => {
      image.toggleAttribute('hidden', !isClosed);
    });

    openImages.forEach((image) => {
      image.toggleAttribute('hidden', isClosed);
    });

    this.#updateToggleLabels();
  }

  #updateToggleLabels() {
    if (!this.#toggleInput) return;

    const isClosed = this.#toggleInput.checked;
    const closedLabel = this.querySelector('[data-state-label="closed"]');
    const openLabel = this.querySelector('[data-state-label="open"]');

    if (closedLabel) {
      closedLabel.dataset.active = isClosed ? 'true' : 'false';
    }

    if (openLabel) {
      openLabel.dataset.active = isClosed ? 'false' : 'true';
    }
  }
}

if (!window.customElements.get('product-module-images')) {
  window.customElements.define('product-module-images', ProductModuleImages);
}
